// extracted by mini-css-extract-plugin
export default {"topWrapper":"PatientFamilyTable_topWrapper__RhiL9","header":"PatientFamilyTable_header__W4eBt","title":"PatientFamilyTable_title__wfZmJ"};